// ✅ In-memory virtual layout manager for frontend
import UploadedLayoutManager from "./UploadedLayoutManager";
import { uuidv4 } from "../utils/uuid";


const layoutEngine = (() => {
  let createdCells = [];     // ✅ manually created cells
  let uploadedCells = [];    // ✅ uploaded from GDS
  let activeCellStack = [];

  const findCell = (name) => createdCells.find(cell => cell.name === name);
  const getCellByName = (name) => createdCells.find(cell => cell.name === name);
  const getCells = () => createdCells;
  const getUploadedCells = () => uploadedCells;
  const setUploadedCells = (newCells) => { uploadedCells = newCells; };

  const reset = () => {
    createdCells = [];
    uploadedCells = [];
    activeCellStack = [];
  };




  const addCell = (name) => {
    if (!findCell(name)) {
      createdCells.push({ name, elements: [], instances: [] });
      window.dispatchEvent(new Event("hierarchy-updated"));
      return true;
    }
    return false;
  };

  // const getCell = (name) => {
  //   return uploadedCells.find(c => c.name === name) || createdCells.find(c => c.name === name);
  // };
//   function getCell(cellName) {
//   // Always return created cell if it exists (it's editable and up-to-date)
//   const createdCell = createdCells.find(cell => cell.name === cellName);
//   if (createdCell) {
//     return createdCell;
//   }
  
//   // Only return uploaded cell if no created version exists
//   return uploadedCells.find(cell => cell.name === cellName);
// }
  
  

  function createsCycle(currentCell, targetCell) {
    if (currentCell === targetCell) return true;
    const target = getCellByName(targetCell);
    if (!target) return false;
    for (let inst of target.instances || []) {
      if (createsCycle(currentCell, inst.ref)) return true;
    }
    return false;
  }
  const addRectangle = (cellName, x1, y1, x2, y2, layer = 1) => {
    const cell = findCell(cellName);
    if (cell) {
      cell.elements.push({ id: uuidv4(), type: 'rectangle', x1, y1, x2, y2, layer });
    }
  };
  const addText = (cellName, text, x, y, layer = 1) => {
    const cell = findCell(cellName);
    if (cell) {
      cell.elements.push({ id: uuidv4(), type: 'text', text, x, y, layer });
    }
  };

  const getActiveCellName = () => {
    return activeCellStack.length > 0 ? activeCellStack[activeCellStack.length - 1] : null;
  };
  const deleteElement = (cellName, elementId) => {
    const cell = findCell(cellName);
    if (cell) {
      cell.elements = cell.elements.filter(el => el.id !== elementId);
    }
  };
  // const addInstance = (parentCell, refCellName, x, y, rotation = 0) => {
  //   const cell = findCell(parentCell);
  //   console.log("💥 Adding instance to cell:", cell);

  //   if (createsCycle(parentCell, refCellName)) {
  //     console.warn(`❌ Cannot insert ${refCellName} into ${parentCell} — would cause circular hierarchy`);
  //     return;
  //   }

  //   if (cell) {
  //     const inst = {
  //       id: uuidv4(),
  //       ref: refCellName,
  //       x,
  //       y,
  //       rotation,
  //       scale: 1,
  //       mirror_x: false, // ✅ default no mirroring
  //       mirror_y: false  // ✅ default no mirroring
  //     };
  //     cell.instances.push(inst);
  //     window.dispatchEvent(new Event("hierarchy-updated"));
  //     console.log("✅ Added instance:", inst);
  //   } else {
  //     console.error("❌ Cell not found:", parentCell);
  //   }
  // };
const addInstance = (parentCell, refCellName, x, y, rotation = 0) => {
    const cell = findCell(parentCell);
    console.log("💥 Adding instance to cell:", cell);

    if (createsCycle(parentCell, refCellName)) {
      console.warn(`❌ Cannot insert ${refCellName} into ${parentCell} — would cause circular hierarchy`);
      return;
    }

    if (cell) {
      const inst = {
        id: uuidv4(),
        ref: refCellName,
        x,
        y,
        rotation,
        scale: 1,
        mirror_x: false, // ✅ default no mirroring
        mirror_y: false  // ✅ default no mirroring
      };
      cell.instances.push(inst);
      window.dispatchEvent(new Event("hierarchy-updated"));
      console.log("✅ Added instance:", inst);
    } else {
      console.error("❌ Cell not found:", parentCell);
    }
  };


 const deleteInstance = (cellName, instanceId) => {
  // const cell = ensureCreatedCell(cellName);
  const cell = findCell(cellName);
  if (!cell) return;

  cell.instances = cell.instances.filter(inst => inst.id !== instanceId);

  window.dispatchEvent(new Event("hierarchy-updated"));
};


  const editElement = (cellName, elementId, updates) => {
    const cell = findCell(cellName);
    if (cell) {
      const el = cell.elements.find(e => e.id === elementId);
      if (el) Object.assign(el, updates);
    }
  };

  const editInstance = (cellName, instanceId, updates) => {
    const cell = findCell(cellName);
    if (cell) {
      const inst = cell.instances.find(i => i.id === instanceId);
      if (inst) Object.assign(inst, updates);
      if (window.canvasEngine?.selectedObjects?.some(o => o.name === inst.ref)) {
        const bbox = layoutEngine.getBoundingBox(inst.ref);
        if (bbox) {
          const updatedObj = {
            name: inst.ref,
            ...bbox,
          };

          const index = window.canvasEngine.selectedObjects.findIndex(o => o.name === inst.ref);
          if (index !== -1) {
            window.canvasEngine.selectedObjects[index] = updatedObj;
            window.canvasEngine.draw3x3DotsOnSelected(); // 🔁 Redraw
          }
        }
      }
    }
  };

  const getAllCellNames = () => {
    return createdCells.map(cell => cell.name);
  };



  // const loadFromGDS = (gdsData) => {
  //   if (!gdsData || !Array.isArray(gdsData)) return;
  
  //   const userSize = gdsData?.[0]?.user_unit || 0.001; // ⛳ fallback if not present
  //   window.canvasEngine.setUseUploadedCells(true);
  //   UploadedLayoutManager.load(gdsData);
  
  //   const nameToCellMap = {};
  //   gdsData.forEach(cell => nameToCellMap[cell.name] = cell);
  
  //   const resultCells = [];
  //   const visited = new Set();
  
  //   const applyInstanceOffsets = (cellName, accumulatedTransform = { x: 0, y: 0, rotation: 0 }) => {
  //     if (visited.has(cellName)) return;
  //     visited.add(cellName);
  
  //     const cell = nameToCellMap[cellName];
  //     if (!cell) return;
  //     console.log("cell name",cell)

  
  //     const newElements = (cell.elements || []).map(el => {
  //       console.log(el.x, el.y)
  //       if (el.type === 'rectangle') {
  //         return {
  //           id: uuidv4(),
  //           type: 'rectangle',
  //           x: (el.x ) / userSize,
  //           y: -(el.y ) / userSize,
  //           width: el.width / userSize,
  //           height: -el.height / userSize,
  //           layer: `${el.layer}`,
  //           datatype: el.datatype ?? 0
  //         };
  //       } else if (el.type === 'Label') {
  //         return {
  //           id: uuidv4(),
  //           type: 'Label',
  //           coordinates: [[
  //             (el.coordinates[0][0] ) / userSize,
  //             -(el.coordinates[0][1] ) / userSize
  //           ]],
  //           name: el.name,
  //           layer: `${el.layer_number}`,
  //           datatype: el.datatype_number ?? 0
  //         };
  //       }
  //       return el;
  //     });
  
  //     const newInstances = (cell.instances || []).map(inst => {
  //       const instX = inst.x ;
  //       const instY = inst.y ;
  
  //       const newInst = {
  //         id: uuidv4(),
  //         ref: inst.name,
  //         x: inst.x  / userSize,
  //         y: -inst.y / userSize,
  //         rotation: inst.rotation || 0,
  //         scale: inst.scale || 1
  //       };
  
  //       // recursively apply offsets to child cell
  //       applyInstanceOffsets(inst.name, { x: instX, y: instY, rotation: 0 });
  
  //       return newInst;
  //     });
  
  //     resultCells.push({ name: cell.name, elements: newElements, instances: newInstances });
  //   };
  
  //   const topCells = gdsData.filter(c =>
  //     !gdsData.some(parent => (parent.instances || []).some(inst => inst.name === c.name))
  //   );
  
  //   topCells.forEach(topCell => applyInstanceOffsets(topCell.name, { x: 0, y: 0, rotation: 0 }));
  
  //   layoutEngine.setUploadedCells(resultCells);
  //   console.log("📥 Final merged cells loaded:", resultCells);
  // };


  function setAllCells(cellsMap) {
  if (!cellsMap || typeof cellsMap !== 'object') return;

  // Separate created vs uploaded cells based on presence in existing arrays
  const existingCreatedNames = new Set(createdCells.map(c => c.name));
  const existingUploadedNames = new Set(uploadedCells.map(c => c.name));

  const newCreatedCells = [];
  const newUploadedCells = [];

  for (const [cellName, cellData] of Object.entries(cellsMap)) {
    const clonedCell = {
      name: cellName,
      elements: Array.isArray(cellData.elements) ? JSON.parse(JSON.stringify(cellData.elements)) : [],
      instances: Array.isArray(cellData.instances) ? JSON.parse(JSON.stringify(cellData.instances)) : []
    };

    if (existingUploadedNames.has(cellName)) {
      newUploadedCells.push(clonedCell);
    } else {
      newCreatedCells.push(clonedCell);
    }
  }

  createdCells = newCreatedCells;
  uploadedCells = newUploadedCells;
}

function getAllCellsMap() {
  const map = {};

  for (const cell of [...createdCells, ...uploadedCells]) {
    map[cell.name] = {
      elements: cell.elements,
      instances: cell.instances
    };
  }

  return map;
}
  const loadFromGDS = (gdsData,userSize) => {
    if (!gdsData || !Array.isArray(gdsData)) return;
  
    // const userSize = gdsData?.[0]?.user_unit || 0.001;
    window.canvasEngine.setUseUploadedCells(true);
    UploadedLayoutManager.load(gdsData);
  
    const nameToCellMap = {};
    gdsData.forEach(cell => nameToCellMap[cell.name] = cell);
  
    const resultCells = [];
  
  
    const applyInstanceOffsets = (cellName, accumulatedTransform = { x: 0, y: 0, rotation: 0 }, path = []) => {
      if (path.includes(cellName)) return;
      const nextPath = [...path, cellName];
  
      const cell = nameToCellMap[cellName];
      if (!cell) return;
      console.log("cell name", cell);
  
      const newElements = (cell.elements || []).map(el => {
        console.log(el.x, el.y);
        if (el.type === 'rectangle') {
          return {
            id: uuidv4(),
            type: 'rectangle',
            x: el.x / userSize,
            y: -el.y / userSize,
            width: el.width / userSize,
            height: -el.height / userSize,
            layer: `${el.layer}`,
            datatype: el.datatype ?? 0,
            layerNumber: `${el.layer}`,
            datatypeNumber: el.datatype ?? 0,
            layerId: `${el.layer}:${el.datatype ?? 0}`,
          };
        } 
        else if (el.type === 'polygon') {
  const scaledPoints = (el.points || []).map(([x, y]) => [x / userSize, -y / userSize]);

  // ✅ normalize once
  const layerNum = `${el.layerNumber ?? el.layer ?? 1}`;
  const dtypeNum = `${el.datatypeNumber ?? el.datatype ?? 0}`;

  return {
    id: uuidv4(),
    type: 'polygon',
    points: scaledPoints,
    layer: layerNum,
    datatype: dtypeNum,
    layerNumber: layerNum,
    datatypeNumber: dtypeNum,
    // don't freeze a wrong id
    layerId: `${layerNum}:${dtypeNum}`,
  };
}
//        else if (el.type === 'label') {
//    const layerNum = `${el.layerNumber ?? el.layer ?? el.layer_number ?? 1}`;
//    const dtypeNum = `${el.datatypeNumber ?? el.datatype ?? el.datatype_number ?? 0}`;
//    return {
//      id: uuidv4(),
//      type: 'label',
//      coordinates: [[
//        el.coordinates?.[0]?.[0] / userSize,
//        -(el.coordinates?.[0]?.[1]) / userSize
//      ]],
//      name: el.name,
//      layer: layerNum,
//      datatype: dtypeNum,
//      layerNumber: layerNum,
//      datatypeNumber: dtypeNum,
//      layerId: `${layerNum}:${dtypeNum}`,
//    };
//  }
  else if (el.type === 'label') {
  const layerNum = `${el.layerNumber ?? el.layer ?? el.layer_number ?? 1}`;
  const dtypeNum = `${el.datatypeNumber ?? el.datatype ?? el.datatype_number ?? 0}`;
  return {
    id: uuidv4(),
    type: 'label',
    coordinates: [[
      el.coordinates?.[0]?.[0] / userSize,
      -(el.coordinates?.[0]?.[1]) / userSize
    ]],
    name: el.name,
    layer: layerNum,
    datatype: dtypeNum,
    layerNumber: layerNum,
    datatypeNumber: dtypeNum,
    layerId: `${layerNum}:${dtypeNum}`,
    // rotation: el.rotation || 0,                      // ✅ add this
    rotation: ((el.rotation || 0) * 180) / Math.PI,   
    justification: el.justification || 'centerleft',  // ✅ ye bhi isi tarah drop ho raha hai
    fontType: el.fontType || 'monospace',              // ✅ ye bhi
  };
}
        return el;
      });
      console.log("usersize:", userSize);
  
      const newInstances = (cell.instances || []).map(inst => {
        const instX = inst.x;
        const instY = inst.y;
  
        // const newInst = {
        //   id: uuidv4(),
        //   ref: inst.name,
        //   x: inst.x / userSize,
        //   y: -inst.y / userSize,
        //   rotation: inst.rotation || 0,
        //   scale: inst.scale || 1,
        //   mirror_x: inst.mirror_x || false  // ✅ include mirror info from backend
        // };

        const newInst = {
  id: uuidv4(),
  ref: inst.name,
  x: inst.x / userSize,
  y: -(inst.y) / userSize,
  rotation: inst.rotation || 0,
  scale: inst.scale || 1,
  mirror_x: !!inst.mirror_x,
  mirror_y: !!inst.mirror_y
};

// --- Recover mirror_y if backend returned X+180° combo ---
const rot = ((newInst.rotation % 360) + 360) % 360;

if (!newInst.mirror_y) {
  if (newInst.mirror_x && Math.abs(rot - 180) < 0.5) {
    newInst.mirror_y = true;
    // restore original rotation
    newInst.rotation = 0;
  }
}

  
        // ✅ Call child recursively with path stack
        applyInstanceOffsets(inst.name, { x: instX, y: instY, rotation: 0 }, nextPath);
  
        return newInst;
      });
      resultCells.push({ name: cell.name, elements: newElements, instances: newInstances });
    };

    const topCells = gdsData.filter(c =>
      !gdsData.some(parent => (parent.instances || []).some(inst => inst.name === c.name))
    );
  
    topCells.forEach(topCell =>
      applyInstanceOffsets(topCell.name, { x: 0, y: 0, rotation: 0 }, [])
    );
  
    layoutEngine.setUploadedCells(resultCells);
    console.log("📥 Final merged cells loaded:", resultCells);
  };
  
  

  // function getUploadedCell(cellName) {
  //   return uploadedCells.find(cell => cell.name === cellName);
  // }
  // In layoutEngine.js - Update getUploadedCell function:
// layoutEngine.js (or helper)
function getUploadedCell(cellName) {
    return uploadedCells.find(cell => cell.name === cellName);
  }

  const getCell = (name) => {
    return uploadedCells.find(c => c.name === name) || createdCells.find(c => c.name === name);
  };
  
  const deleteCell = (name) => {
  const index = createdCells.findIndex(cell => cell.name === name);
  if (index !== -1) {
    const deleted = createdCells.splice(index, 1);
    console.log("🧹 Deleted cell:", deleted[0]?.name);
  } else {
    console.warn("⚠️ Cell not found to delete:", name);
  }
};

  const showAsTop = (cellName) => {
    if (!findCell(cellName)) {
      createdCells.push({ name: cellName, elements: [], instances: [] });
      console.warn(`📦 Dynamically added cell for: ${cellName}`);
    }
    activeCellStack.push(cellName);
    console.log("🔁 Switched to cell:", cellName);
  };

  const exitShowAsTop = () => {
    if (activeCellStack.length > 1) {
      const popped = activeCellStack.pop();
      console.log("🔙 Exited cell:", popped, "➡️ Now in:", activeCellStack.at(-1));
    } else {
      console.warn("⚠️ Already at TOP, can't go back further.");
    }
  };

  const getTopCell = () => {
  const topCellName = activeCellStack.length > 0 ? activeCellStack.at(-1) : null;
  
  return getCell(topCellName);  // ✅ object return hoga, not just name
};



const getBoundingBox = (name) => {
  const cell = layoutEngine.getCellByName(name);
  if (!cell) {
    console.log("❌ Cell not found for", name);
    return null;
  }

  console.log("📂 Cell found for", name, cell);

  let bboxes = [];

  if (cell.elements?.length) {
  console.log("📏 Collecting BBoxes from elements...");
  for (const el of cell.elements) {
    const { x, y, width, height } = el;
    console.log("🟨 Element BBox:", { x, y, width, height });
    bboxes.push({ x, y, width, height });
  }
}

if (cell.instances?.length) {
  console.log("📦 Collecting BBoxes from instances...");
  for (const inst of cell.instances) {
    const bbox = layoutEngine.getBoundingBox(inst.ref);
    if (bbox) {
      const x = inst.x + bbox.x;
      const y = inst.y + bbox.y;
      bboxes.push({
        x,
        y,
        width: bbox.width,
        height: bbox.height,
      });
      console.log("🧩 Instance BBox (translated):", inst.ref, { x, y, width: bbox.width, height: bbox.height });
    }
  }


  } else {
    console.log("⚠️ No elements or instances found in cell", name);
  }

  if (!bboxes.length) {
    console.log("❌ No bounding boxes collected");
    return null;
  }

  let minX = Infinity, minY = Infinity, maxX = -Infinity, maxY = -Infinity;
  for (const b of bboxes) {
    minX = Math.min(minX, b.x);
    minY = Math.min(minY, b.y);
    maxX = Math.max(maxX, b.x + b.width);
    maxY = Math.max(maxY, b.y + b.height);
  }

  const finalBox = {
    x: minX,
    y: minY,
    width: maxX - minX,
    height: maxY - minY,
  };

  console.log("✅ Final BBox for pattern", name, "=>", finalBox);
  return finalBox;



};


const renameCell = (oldName, newName) => {
    if (!oldName || !newName || oldName === newName) return false;

    const trimmed = newName.trim();
    if (!trimmed) return false;

    // Check for name collision (excluding the cell being renamed itself)
    const allNames = [
      ...createdCells.map(c => c.name),
      ...uploadedCells.map(c => c.name),
    ];
    if (allNames.includes(trimmed) && trimmed !== oldName) {
      console.warn(`❌ renameCell: "${trimmed}" already exists`);
      return false;
    }

    let renamed = false;

    // Rename in createdCells
    const createdCell = createdCells.find(c => c.name === oldName);
    if (createdCell) {
      createdCell.name = trimmed;
      renamed = true;
    }

    // Rename in uploadedCells
    const uploadedCell = uploadedCells.find(c => c.name === oldName);
    if (uploadedCell) {
      uploadedCell.name = trimmed;
      renamed = true;
    }

    if (!renamed) {
      console.warn(`❌ renameCell: "${oldName}" not found in any cell list`);
      return false;
    }

    // Update all inst.ref references across every cell
    const allCells = [...createdCells, ...uploadedCells];
    for (const cell of allCells) {
      for (const inst of cell.instances || []) {
        if (inst.ref === oldName) {
          inst.ref = trimmed;
        }
      }
    }

    // Update active-cell stack
    for (let i = 0; i < activeCellStack.length; i++) {
      if (activeCellStack[i] === oldName) {
        activeCellStack[i] = trimmed;
      }
    }

    // ✅ Rename the RectangleLibrary instances key so drawAll() still finds
    // rectangles under the new name (prevents color change + duplicate overlap).
    try {
      const InstanceLibrary = require('../libraries/RectangleLibrary').default;
      if (typeof InstanceLibrary?.renameCellKey === 'function') {
        InstanceLibrary.renameCellKey(oldName, trimmed);
      }
    } catch (e) {
      console.warn('renameCell: could not update RectangleLibrary key', e);
    }

    window.dispatchEvent(new Event('hierarchy-updated'));

    // Trigger canvas redraw so the new name is reflected immediately
    if (window.canvasEngine?.draw) {
      window.canvasEngine.draw();
    }

    console.log(`✅ renameCell: "${oldName}" → "${trimmed}"`);
    return true;
  };

  return {
    getCells,
    getUploadedCells,
    setUploadedCells,
    reset,
    addCell,
    addRectangle,
    addText,
    addInstance,
    deleteElement,
    deleteInstance,
    editElement,
    editInstance,
    getCellByName,
    getActiveCellName,
    deleteCell,
    showAsTop,
    exitShowAsTop,
    getAllCellNames,
    loadFromGDS,
    getCell,
    getUploadedCell,
    setAllCells,
    getAllCellsMap,
    getBoundingBox,
    getTopCell,
    renameCell
  };
})();

if (typeof window !== 'undefined') {
  window.layoutEngine = layoutEngine;
}

export default layoutEngine;
